<form (ngSubmit)="save()" #f="ngForm">

  <div class="edit-panel__close" (click)="cancel()">
    <i class="material-icons">highlight_off</i>
  </div>

  <div *ngIf="isLoading">
    <loading-spinner></loading-spinner>
  </div>

  <div *ngIf="!isLoading && question">
    <h2 class="edit-panel__heading">{{title}}</h2>

    <!--RENDER FOR EACH OPTION-->
    <!--<ul *ngFor="let option of question.options" class="questionOption edit-panel__list edit-panel__main-edit edit-panel__options">-->
    <div *ngFor="let option of question.options" class="grid grid--row-2">

      <ul class="grid grid--row-3">
        <li>
          <label>Criteria/Supplimentary</label>
          <div class="edit-panel__row">
            <mat-form-field>
              <!--<mat-label>Question Type</mat-label>-->
              <div class="validation__holder">
                <mat-select [(ngModel)]="question.questionTypeId" name="questionType" placeholder="Criteria/Supplimentary" #ot required>
                  <mat-option *ngFor="let questionType of questionTypes" [value]="questionType.questionTypeId">
                    {{questionType.description}}
                  </mat-option>
                </mat-select>
                <div class="validation"></div>
              </div>
            </mat-form-field>
          </div>
        </li>

        <li>
          <label>Question Type </label>
          <div class="edit-panel__row">
            <mat-form-field>
              <div class="validation__holder">
                <mat-select [(ngModel)]="option.optionTypeId" name="optionType" placeholder="Question Type" #ot required (selectionChange)="optionTypeChanged(option)">
                  <mat-option *ngFor="let optionType of optionTypes" [value]="optionType.optionTypeId">
                    {{optionType.description}}
                  </mat-option>
                </mat-select>
                <div class="validation"></div>
              </div>
            </mat-form-field>
            <div class="edit-panel__help" matTooltip="How will the possible answers be displayed?" matTooltipPosition='right'>
              <mat-icon>help</mat-icon>
            </div>
          </div>
        </li>

        <li>
          <label>Validation</label>
          <div class="edit-panel__row">
            <mat-checkbox class="example-margin" [(ngModel)]="question.isRequired" name="isRequired">Is Required?</mat-checkbox>
            <div class="edit-panel__help" matTooltip="If checked, users MUST answer this question" matTooltipPosition='right'>
              <mat-icon>help</mat-icon>
            </div>
          </div>
        </li>
      </ul>

      <ul class="grid grid--row-2">
        <li>
          <label>Question Text</label>
          <div class="edit-panel__row">
            <mat-form-field>
              <div class="validation__holder">
                <textarea matInput [(ngModel)]="question.name" name="Name" maxlength="2000" placeholder="Question Text" required></textarea>
                <div class="validation"></div>
              </div>
            </mat-form-field>
            <div class="edit-panel__help" matTooltip="This is how the question will be displayed in the forms" matTooltipPosition='right'>
              <mat-icon>help</mat-icon>
            </div>
          </div>
        </li>

    <!--<li class="edit-panel__item edit--group-panel row">
          <mat-form-field fxFlex="100" class="edit-panel__material-holder">
            <textarea matInput [(ngModel)]="question.description" name="questionDescription" required
                      placeholder="Question"></textarea>
          </mat-form-field>
          <div class="edit-panel__help" matTooltip="This is how the question will be displayed in the forms" matTooltipPosition='right'>
            <mat-icon>help</mat-icon>
          </div>
        </li>-->

        <li>
          <label>Question Help Text</label>
          <div class="edit-panel__row">
            <mat-form-field>
              <div class="validation__holder">
                <textarea matInput [(ngModel)]="question.helpText" name="questionHelpText" placeholder="Question Help Text"></textarea>
              </div>
            </mat-form-field>
            <div class="edit-panel__help" matTooltip="This will be displayed when the ? icon is hovered" matTooltipPosition='right'>
              <mat-icon>help</mat-icon>
            </div>
          </div>
        </li>
      </ul>


      <ul class="grid grid--row-1">
        <!--ANY LIST TYPE CONTROL-->
        <li *ngIf="isListTypeControl(option.optionTypeId)">
          <div *ngIf="isListTypeControl(option.optionTypeId)" cdkDropList id="ov" class="edit-panel__item"
               cdkDropListData="option.optionValues" (cdkDropListDropped)="dropOptionValue($event, option.optionValues)">

            <h5 class="heading">Options</h5>
            <ul class="edit-panel__sortable-list">
              <li *ngFor="let optionValue of option.optionValues" (click)="selectOptionValue(optionValue)" class="edit-panel__sortable-item" cdkDropList cdkDrag>
                <label class="edit-panel__sortable-name">{{optionValue.description}}</label>
                <div class="edit-panel__sortable-item-buttons">
                  <label class="edit-panel__sortable-score">{{optionValue.score}}</label>
                  <!--<i class="material-icons form-edit__move-icon">open_with</i>-->

                  <i class="material-icons edit-panel__add-group-icon" title="add question group"
                     (click)="showOptionValueQuestionGroup(optionValue)" [ngClass]="{'blue' : optionValue.optionValueQuestionGroups.length > 0}">control_point</i>
                  <div class="edit-panel__group-count" [ngClass]="{'blue' : optionValue.optionValueQuestionGroups.length > 0}">{{optionValue.optionValueQuestionGroups.length}}</div>

                  <i class="material-icons edit-panel__attach-icon" title="attach advice files"
                     (click)="showOptionValueAssessmentMessage(optionValue)" [ngClass]="{'blue' : optionValue.assessmentMessages.length > 0}">attach_file</i>
                  <div class="edit-panel__attach-count" [ngClass]="{'blue' : optionValue.assessmentMessages.length > 0}">{{optionValue.assessmentMessages.length}}</div>

                  <!--<i class="material-icons form-edit__edit-icon edit--group active" title="Edit"
          (click)="selectOptionValue(optionValue)">edit</i>-->

                  <i class="material-icons form-edit__delete-icon" title="Delete"
                     (click)="deleteOptionValue(option.optionValues, optionValue)">delete</i>
                </div>
              </li>
            </ul>
          </div>

          <div class="button__row" style="margin-top:5px;">
            <div>&nbsp;</div>
            <a (click)="createNewOptionValue(option.optionValues, option.optionId)" class="button--box blue add">New option value</a>
          </div>

          <div class="edit-panel__edit-options" *ngIf="isOptionValueSelected">
            <!--<ul id="optionValueData" class="edit-panel__edit-list" ngModelGroup="optionValueDescription"
  #optionValueDescription="ngModelGroup" *ngIf="isOptionValueSelected">-->
            <h5 class="heading">Option Value</h5>
            <div id="optionValueData" ngModelGroup="optionValueDescription" #optionValueDescription="ngModelGroup" *ngIf="isOptionValueSelected">
              <ul class="grid grid--row-3">
                <li>
                  <label>Option Score</label>
                  <mat-form-field>
                    <input id="optionValueScore" type="number" matInput [(ngModel)]="selectedOptionValue!.score" name="optionValueScore" required placeholder="Score" />
                  </mat-form-field>
                </li>

                <li>
                  <label>Referrer Partner Type</label>
                  <mat-form-field *ngIf="selectedOptionValue">
                    <mat-select id="partnerTypeId" name="partnerTypeId" placeholder="Referral Partner Type" [(ngModel)]="selectedOptionValue!.partnerTypeId">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let item of partnerTypes" [value]="item.partnerTypeId">{{ item.description }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>

                <li>
                  <label>High Risk</label>
                  <div class="edit-panel__row">
                    <mat-checkbox class="example-margin" [(ngModel)]="selectedOptionValue!.isHighRiskCategory" name="isHighRiskCategory">Denotes high safety risk</mat-checkbox>
                    <div class="edit-panel__help" matTooltip="If this option is selected, the occupier would automatically be deemed as being at high risk and would require a visit" matTooltipPosition='right'>
                      <mat-icon>help</mat-icon>
                    </div>
                  </div>
                </li>

                <li>
                  <label>Description</label>
                  <mat-form-field>
                    <div class="validation__holder">
                      <textarea matInput id="selectedOptionDescription" [(ngModel)]="selectedOptionValue!.description" name="selectedOptionDescription" placeholder="Description" required>{{selectedOptionValue!.description}}</textarea>
                      <div class="validation"></div>
                    </div>
                  </mat-form-field>
                </li>

                <li>
                  <label>Onward Referral Summary</label>
                  <mat-form-field>
                    <textarea matInput id="referralSummaryText" [(ngModel)]="selectedOptionValue!.onwardReferralSummary" name="OnwardReferralSummary" placeholder="Onward Referral Summary">{{selectedOptionValue!.onwardReferralSummary}}</textarea>
                  </mat-form-field>
                </li>

                <li *ngIf="isDisplayHelpTextField(option.optionTypeId)">
                  <label>Help Text</label>
                  <mat-form-field>
                    <textarea matInput id="selectedOptionHelpText" [(ngModel)]="selectedOptionValue!.helpText" name="selectedOptionHelpText" placeholder="Help Text">{{selectedOptionValue!.helpText}}</textarea>
                  </mat-form-field>
                </li>
              </ul>

              <div class="button__row" style="margin-bottom:0">
                <div></div>
                <button (click)="optionValueAdded(option)" [disabled]="!optionValueDescription.valid" class="button--box blue select">Done</button>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <ul class="grid grid--row-1">
        <!--ANY YES/NO CONTROL Part 1-->
        <li *ngIf="isYesNoControlType(option.optionTypeId)">
          <div *ngIf="isYesNoControlType(option.optionTypeId)" cdkDropList id="ov" class="edit-panel__item"
               cdkDropListData="option.optionValues" (cdkDropListDropped)="dropOptionValue($event, option.optionValues)">

            <h5 class="heading">Options</h5>
            <ul class="edit-panel__sortable-list">
              <li class="edit-panel__sortable-item" cdkDropList *ngFor="let optionValue of option.optionValues" cdkDrag
                  (click)="selectOptionValue(optionValue)">
                <label class="edit-panel__sortable-name">{{optionValue.description}}</label>
                <div class="edit-panel__sortable-item-buttons">

                  <label class="edit-panel__sortable-score">{{optionValue.score}}</label>

                  <i class="material-icons edit-panel__add-group-icon" title="add question group"
                     (click)="showOptionValueQuestionGroup(optionValue)" [ngClass]="{'blue' : optionValue.optionValueQuestionGroups.length > 0}">control_point</i>
                  <div class="edit-panel__group-count" [ngClass]="{'blue' : optionValue.optionValueQuestionGroups.length > 0}">{{optionValue.optionValueQuestionGroups.length}}</div>

                  <i class="material-icons edit-panel__attach-icon" title="attach advice files"
                     (click)="showOptionValueAssessmentMessage(optionValue)" [ngClass]="{'blue' : optionValue.assessmentMessages.length > 0}">attach_file</i>
                  <div class="edit-panel__attach-count" [ngClass]="{'blue' : optionValue.assessmentMessages.length > 0}">{{optionValue.assessmentMessages.length}}</div>
                  <!--<i class="material-icons edit-panel__delete-icon" title="remove">close</i>-->
                </div>
              </li>
            </ul>
          </div>

          <div *ngIf="isYesNoControlType(option.optionTypeId)" cdkDropList id="ov" class="edit-panel__edit-options" cdkDropListData="option.optionValues" (cdkDropListDropped)="dropOptionValue($event, option.optionValues)" style="margin-top:20px;">
            <!--<ul id="yesNoData" ngModelGroup="yesNoDescription" #yesNoDescription="ngModelGroup" *ngIf="isOptionValueSelected" class="edit-panel__edit-list">-->
            <h5 class="heading">Option Value</h5>
            <div id="yesNoData" ngModelGroup="yesNoDescription" #yesNoDescription="ngModelGroup" *ngIf="isOptionValueSelected" class="grid grid--row-1">
              <ul class="grid grid--row-3">

                <li>
                  <mat-form-field>
                    <div class="validation__holder">
                      <input matInput id="selectedOptionScore" type="number" [(ngModel)]="selectedOptionValue!.score"
                             name="selectedOptionScore" placeholder="Score" required />
                      <div class="validation"></div>
                    </div>
                  </mat-form-field>
                </li>

                <li>
                  <mat-form-field *ngIf="selectedOptionValue">
                    <mat-select id="partnerTypeId" name="partnerTypeId" placeholder="Referral Partner Type" [(ngModel)]="selectedOptionValue!.partnerTypeId">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let item of partnerTypes" [value]="item.partnerTypeId">{{ item.description }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>

                <li class="edit-panel__row">
                  <div class="edit-panel__row">
                    <mat-checkbox class="example-margin" [(ngModel)]="selectedOptionValue!.isHighRiskCategory" name="isRequired">Denotes high safety risk</mat-checkbox>
                    <div class="edit-panel__help" matTooltip="If this option is selected, the occupier would automatically be deemed as being at high risk and would require a visit" matTooltipPosition='right'>
                      <mat-icon>help</mat-icon>
                    </div>
                  </div>
                </li>

                <li>
                  <mat-form-field>
                    <div class="validation__holder">
                      <textarea matInput [(ngModel)]="selectedOptionValue!.description" name="selectedOptionDescription"
                                placeholder="Description" required>{{selectedOptionValue!.description}}</textarea>
                      <div class="validation"></div>
                    </div>
                  </mat-form-field>
                </li>

                <li>
                  <mat-form-field>
                    <textarea matInput id="referralSummaryText" [(ngModel)]="selectedOptionValue!.onwardReferralSummary" name="OnwardReferralSummary" placeholder="Onward Referral Summary">{{selectedOptionValue!.onwardReferralSummary}}</textarea>
                  </mat-form-field>
                </li>
              </ul>

              <div class="button__row" style="margin-bottom:0;">
                <div></div>
                <!--<input type="button" value="Done" (click)="optionValueAdded(option)" [disabled]="!yesNoDescription.valid" class="button--box blue add button--done-small" />-->
                <button (click)="optionValueAdded(option)" [disabled]="!yesNoDescription.valid" class="button--box blue done">Done</button>
              </div>

            </div>
          </div>
        </li>

        <!--OPTION VALUE QUESTION  GROUP-->
        <li *ngIf="isOptionValueQuestionGroupSelected">

          <div *ngIf="isOptionValueSelected" class="edit-panel__item edit--group-panel">
            <div class="edit-panel__add-group">

              <h5 class="edit-panel__add-group-title">Add sub-group to option</h5>
              <ul cdkDropList class="edit-panel__add-group-list"
                  cdkDropListData="selectedOptionValue.optionValueQuestionGroups"
                  (cdkDropListDropped)="dropOptionValueQuestionGroup($event, selectedOptionValue!.optionValueQuestionGroups)">
                <li class="edit-panel__add-group-item" *ngFor="let ovqg of selectedOptionValue!.optionValueQuestionGroups"
                    cdkDropList cdkDrag>
                  <a class="button--box">
                    <span>{{ovqg.questionGroup?.name}}</span>
                    <!--<i class="material-icons form-edit__move-icon">open_with</i>-->
                    <span>
                      <i class="material-icons form-edit__delete-icon" title="Delete"
                         (click)="deleteOptionValueQuestionGroup(ovqg.questionGroupId)">delete</i>
                    </span>
                  </a>
                </li>
              </ul>

              <div *ngIf="isOptionValueSelected" class="edit-panel__item edit--group-panel">
                <div class="optionValueQuestionGroup">
                  <div *ngIf="isAddingOptionValueQuestionGroup">
                    <app-option-value-question-group [questionGroups]="questionGroups"
                                                     (questionGroupSelected)="optionValueQuestionGroupSelected($event)">
                    </app-option-value-question-group>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isOptionValueSelected" class="edit-panel__item edit--group-panel center">
            <div (click)="createNewOptionValueQuestionGroup()" class="form-edit__add-group-icon form-edit__edit-icon">
              <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true">add_circle_outline</mat-icon>
              <span>New question group</span>
            </div>
          </div>
        </li>

        <!--ASSESSMENT MESSAGE-->
        <li *ngIf="isOptionValueAssessmentMessageSelected">
          <div class="edit-panel__item edit--group-panel">
            <div class="edit-panel__add-attachments">
              <h5 class="edit-panel__add-attachments-title">Add assessment messages to option</h5>

              <ul class="edit-panel__add-attachments-list">
                <li class="edit-panel__add-attachments-item" *ngFor="let am of selectedOptionValue!.assessmentMessages">
                  <a class="button--box" (click)="editAssessmentMessage(am.assessmentMessageId)">
                    <span>{{am.title}}</span>
                    <span>
                      <i class="material-icons form-edit__edit-icon" title="Edit"
                         (click)="editAssessmentMessage(am.assessmentMessageId)">edit</i>
                      <i class="material-icons form-edit__delete-icon" title="Delete"
                         (click)="deleteAssessmentMessage(am.assessmentMessageId)">delete</i>
                    </span>
                  </a>
                </li>
              </ul>

              <div *ngIf="isAddingAssessmentMessageToQuestionGroup" class="edit-panel__item edit--group-panel">
                <app-assessment-messages [optionValueId]="selectedOptionValue!.optionValueId" [isEditMode]="false"
                                         (assessmentMessageAdded)="assessmentMessageAdded($event)"></app-assessment-messages>
              </div>

              <div *ngIf="isEditingAssessmentMessage" class="edit-panel__item edit--group-panel">
                <app-assessment-messages [assessmentMessage]="selectedAssessmentMessage" [isEditMode]="true"
                                         (assessmentMessageAdded)="assessmentMessageAdded($event)"></app-assessment-messages>
              </div>
            </div>

            <div (click)="createNewAssessmentMessage()" class="form-edit__add-group-icon form-edit__edit-icon center"
                 style="color: white">
              <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true">add_circle_outline</mat-icon>
              <span>New assessment message</span>
            </div>
          </div>
        </li>

      </ul>

      <div class="button__row">
        <div></div>
        <button type="submit" value="save" class="button--box blue save" [disabled]="isSubmitDisabled()">Save</button>
      </div>
    </div>
  </div>
</form>
